import React from "react";
import { useTranslation } from "i18n";
import ProfileCard from "pages/Profile/components/common/ProfileCard";
import { useGetTraining } from "pages/Profile/hooks/useGetTraining";
import ExpandableText from "pages/Profile/components/common/ExpandableText";
import { TRAINING_FULL_PATH } from "shared/constants";

interface Props {
  isEdit?: boolean;
}

const TrainingSection = ({ isEdit }: Props) => {
  const { t } = useTranslation();
  const { isLoading, notes = "" } = useGetTraining();

  return (
    <ProfileCard
      className="dark:text-white/90"
      isEdit={isEdit}
      isLoading={isLoading}
      editToPath={TRAINING_FULL_PATH}
    >
      <h2 className="text-m uppercase dark:text-white">
        {t("performer:profile.training.title")}
      </h2>

      <ExpandableText textClassName="text-s" text={notes} limit={900} />
    </ProfileCard>
  );
};

export default TrainingSection;
